<div class="tile-for-wizzard" (click)="handleWizzardProductClick($event)"
    [ngClass]="{'is-unavailable': !isAvailable,'is-disabled': (isDisabled$ | async), 'is-selected': (isSelected$ | async), 'is-clickable': isClickable$ | async, '-page-limit-reached': isPageLimitReached$ | async}">
    <div class="tile-for-wizzard__inner">

        <ng-container *ngIf="canUseModifiers">
            <shared-quick-selector (click)="stopPropagation($event)"
                *ngIf="(isSelected$ | async) && (ingredientOptions$ | async)?.length > 0"
                class="tile-for-wizzard__ingredient-selector" (onSelected)="onIngredientSelected($event)"
                [selected]="(ingredientSelected$ | async)" [options]="ingredientOptions$ | async">
            </shared-quick-selector>
        </ng-container>

        <shared-indicator
            *ngIf="(isSelected$ | async) && ((ingredientOptions$ | async)?.length === 0 || !(ingredientOptions$ | async) || canUseModifiers === false)"
            [feel]="indicatorFeel" icon="checkmark" [size]="indicatorSize" class="tile-for-wizzard__selected">
        </shared-indicator>

        <div class="tile-for-wizzard__hd">


            <div class="tile-for-wizzard__extra-price" *ngIf="canShowNextPrice$ | async">
                +{{nextPriceForProduct$ | async | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}</div>

        </div>

        <shared-thumb-for-wizzard-product [title]="wizzardProduct?.ProductName" class="tile-for-wizzard__thumb"
            [loading]="(image$ | async)?.isDownloading" [src]="(image$ | async)?.data?.ImageUrl"
            [bgColor]="wizzardProduct?.BackgroundColor">
        </shared-thumb-for-wizzard-product>

        <div class="tile-for-wizzard__bd">
            <div class="tile-for-wizzard__title">
                <h5 class="tile-for-wizzard__h">{{wizzardProduct?.ProductName}}</h5>
            </div>
        </div>


        <div class="tile-for-wizzard__ft">

            <ng-container *ngIf="!isAvailable">
                <div class="tile-for-wizzard__hint is-disabled">
                    <span class="tile-for-wizzard__hint-label">Unavailable</span>
                </div>
            </ng-container>

            <ng-container *ngIf="isAvailable">
                <div class="tile-for-wizzard__hint" *ngIf="!(isSelected$ | async)"
                    [ngClass]="{'is-disabled': (isClickable$ | async) === false}">
                    <span class="tile-for-wizzard__hint-label">Add</span>
                    <span class="tile-for-wizzard__hint-value"
                        *ngIf="nextPriceForProduct$ | async">+{{nextPriceForProduct$ | async | currency}}</span>
                </div>

                <div class="tile-for-wizzard__hint" *ngIf="(showRemoveForOneAllowed$ | async)">
                    <span class="tile-for-wizzard__hint-label">Remove</span>
                </div>

                <shared-quantity (onIncrement)="handleIncrement($event)" (onDecrement)="handleDecrement($event)"
                    [max]="wizzardProduct?.MaximumQuantity" (onRemove)="handleRemove($event)"
                    [canIncrement]="!(isPageLimitReached$ | async)" [remove]="true" class="tile-for-wizzard__quantity"
                    *ngIf="(showQuantityButtons$ | async)" mode="mini" [disabled]="(isDisabled$ | async)"
                    [quantity]="quantity$ | async">
                </shared-quantity>
            </ng-container>

        </div>


    </div>
</div>
